import type { PositionTypeName } from '@/components/root/details/tabs/detailedValuation/grid/positionDetailsDrawer/template';
import { type PayloadAction, createSlice } from '@reduxjs/toolkit';
import type { SigmaOperation } from '../operations/model';

export type PositionId = {
  isin: string,
  rootId: string,
  currency: string, // valuation currency
  positionType: PositionTypeName,
}

type PositionState = {
  positionDisplayedInDrawer: PositionId | null;
  sigmaOperationDisplayedInDrawer : SigmaOperation | null;
};
const initialState: PositionState = {
  positionDisplayedInDrawer: null,
  sigmaOperationDisplayedInDrawer: null,
};

export const positionSlice = createSlice({
  name: 'position',
  initialState,
  reducers: {
    setPositionDisplayedInDrawer: (state, { payload }: PayloadAction<PositionId | null>) => {
      state.positionDisplayedInDrawer = payload;
    },
    setSigmaOperationDisplayedInDrawer: (state, { payload }: PayloadAction<SigmaOperation | null>) => {
      state.sigmaOperationDisplayedInDrawer = payload;
    }
  },
  selectors: {
    positionDisplayedInDrawer: (state) => state.positionDisplayedInDrawer,
    sigmaOperationDisplayedInDrawer: (state) => state.sigmaOperationDisplayedInDrawer,
  },
});

export const { 
  positionDisplayedInDrawer,
  sigmaOperationDisplayedInDrawer,
 } = positionSlice.selectors;
export const { 
  setPositionDisplayedInDrawer,
  setSigmaOperationDisplayedInDrawer,
} = positionSlice.actions;
